<wbo-select-option [value]="OrderActionType.PAGE_CUSTOMER" label="wbo.order-action-display.edit.option.actionType.pageCustomer">
</wbo-select-option>
<wbo-select-option [value]="OrderActionType.DISPLAY_ORDER_READY" label="wbo.order-action-display.edit.option.actionType.displayOrderReady">
</wbo-select-option>
